/* eslint-disable camelcase */
import { useState } from "react";
import { AxiosRequestConfig } from "axios";
import { UseComboboxStateChange } from "downshift"; // eslint-disable-line import/no-extraneous-dependencies
import { ComposableHeaderDropdownProviderProps, IndexedObject, Search } from "../../main";
import { CompanySuggestion } from "../../types";
import {
    FetchCompanySuggestionsPublicConfig,
    fetchCompanySuggestionsPublic,
} from "../../utils/api";

const formatCompanySuggestions = (companySuggestions: CompanySuggestion[]) => companySuggestions.slice(0, 4).map((companyResult: CompanySuggestion) => {
    const { text, value } = companyResult;
    const { short_name } = value;
    return {
        label: `${text}`,
        value: `/profiles/${short_name}`,
    };
});

type UpdateInputProps = {
    changes: UseComboboxStateChange<IndexedObject>;
    fetchConfig: FetchCompanySuggestionsPublicConfig;
    setItems: (items: IndexedObject[]) => void;
};

const updateInput = async ({ changes, fetchConfig, setItems }: UpdateInputProps) => {
    const { inputValue } = changes;
    const jobSearchItem = {
        label: String(inputValue),
        value: `/search/keyword/${inputValue}/`,
    };
    if (inputValue) {
        setItems([jobSearchItem]);
        const companyResults = await fetchCompanySuggestionsPublic(inputValue, fetchConfig);
        const companyList = companyResults?.length ? formatCompanySuggestions(companyResults) : [];
        setItems([jobSearchItem].concat(companyList));
    } else {
        setItems([]);
    }
};

export type UseCompanySearchProps = {
    debounceWait?: number;
    fetchConfig: FetchCompanySuggestionsPublicConfig;
    icon?: React.ReactNode | null;
    inputId?: string;
    onInputChange?: (changes: UseComboboxStateChange<IndexedObject>) => void;
};

export const useCompanySearch = ({
    debounceWait = 10,
    fetchConfig,
    icon,
    inputId = "search-input",
    onInputChange = () => {},
}: UseCompanySearchProps): ComposableHeaderDropdownProviderProps => {
    const [dropdownItems, setDropdownItems] = useState([] as IndexedObject[]);

    return {
        IconComponent: (icon ?? Search) as React.ReactNode,
        debounceWait,
        dropdownList: dropdownItems,
        inputId,
        onInputChange: (changes: UseComboboxStateChange<IndexedObject>) => {
            updateInput({
                changes,
                fetchConfig,
                setItems: setDropdownItems,
            });
            onInputChange(changes);
        },
        noResultsMessage: " ",
    };
};
